// The game's control reference, as data. Shared by the /help modal and the controls page of the
// character-creation screen so the two can never drift apart.
//
// Written for the camp a new player is dropped into (an ember room): alongside the world controls
// every room has, the entries cover the camp-only ones -- firewood, orders, the HUD chips --
// because that is where someone reading this is actually standing.
//
// KEEP EACH BODY TO ONE LINE. The /help modal renders these unwrapped at size 14 into an 800-wide
// screen (about 70 characters) and stacks them down a 460px column, so a body that wraps pushes the
// last entries off the bottom. The controls page wraps the same text into its own columns.

export interface HelpEntry {
    title: string
    body: string
}

export const HELP_ENTRIES: HelpEntry[] = [
    { title: "Movement", body: "WASD or the arrow keys. Hold SHIFT to run, press J to jump." },
    { title: "Interact", body: "Click or tap a thing to act on it. Several choices open a wheel." },
    { title: "Attack", body: "Press SPACE, or click. Hold a click on someone to swing instead." },
    { title: "Firewood", body: "An axe fells trees. Carry the wood to the fire and feed it in." },
    { title: "Inventory", body: "Press 'e' or the ITEMS chip. Keys 1-6 ready a slot, 'q' drops one." },
    { title: "Crafting", body: "Press 'c' to open the crafting screen." },
    { title: "Camp orders", body: "Click one of your camp for their orders. Hold CTRL to order them all." },
    { title: "Camp HUD", body: "The map, your roster, the wave countdown. Click a chip to reopen one." },
    { title: "Chat & help", body: "ENTER to chat. '/help' for this list, '/register' to save progress." },
]
